import { render, staticRenderFns } from "./FinanceSum.vue?vue&type=template&id=484f5465&scoped=true&lang=pug"
import script from "./FinanceSum.vue?vue&type=script&lang=js"
export * from "./FinanceSum.vue?vue&type=script&lang=js"
import style0 from "./FinanceSum.vue?vue&type=style&index=0&id=484f5465&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484f5465",
  null
  
)

export default component.exports